<ng-template #content let-modal>
    <div class="modal-header">
        <h4>{{modalHeader}}</h4>
    </div>
    <div class="modal-body">
        <div class="col-md-10">
            <form>
                <div class="form-row">
                    <div class="form-group col-md-10">
                        <label for="name">Name *</label>
                        <!-- setting autocomplete to a random string prevents the browser from trying to autofill -->
                        <input class="form-control" autocomplete="dont_d0_it_brows3r_i_mEAN_IT"
                            [(ngModel)]="studentName" name="studentFOO" placeholder="Enter student name"
                            [ngbTypeahead]="searchExistingStudents" (selectItem)="existingStudentSelected($event.item)"
                            [resultFormatter]="resultFormatter" [inputFormatter]="inputFormatter" />
                        <div *ngIf="enteredStudentExists()" class="user-type">
                            existing student, ID: {{data.ID}}
                        </div>
                    </div>
                </div>
            </form>
        </div>

        <div *ngIf="!enteredStudentExists()" class="col-md-10">
            <form>
                <div class="form-row">
                    <div class="form-group col-md-10">
                        <div class="d-flex">
                            <label for="externalId">Student ID</label>
                            <span class="ml-1 extra-info">(Required to preserve year-to-year progress)</span>
                        </div>
                        <!-- setting autocomplete to a random string prevents the browser from trying to autofill -->
                        <input class="form-control" autocomplete="dont_d0_it_brows3r_i_mEAN_IT"
                            [(ngModel)]="data.ExternalID" name="externalId" placeholder="Enter student ID" />
                    </div>
                </div>
            </form>
        </div>

        <div *ngIf="!enteredStudentExists()" class="col-md-6">
            <div class="detail-name">Course *</div>
            <select class="form-control form-group" [(ngModel)]="courseCode">
                <option *ngFor="let course of selectableCourses" [disabled]="course.Code === 'Default'"
                    [ngValue]="course.Code">
                    {{ course.Description }}
                </option>
            </select>
        </div>

        <div *ngIf="!enteredStudentExists()" class="col-md-6">
            <div class="detail-name">Grade Level</div>
            <select class="form-control form-group" id="gradeLevel" [(ngModel)]="gradeLevel" name="gradeLevel"
                placeholder="--">
                <option *ngFor="let gradeLevelOpt of studentGradeLevelOptions" [value]="gradeLevelOpt">
                    {{ getGradeLevelString(gradeLevelOpt) }}</option>
            </select>
        </div>

        <span *ngIf="!enteredStudentExists()" class="col-md-3">* Required</span>

    </div>
    <div class="modal-footer" style="border: none">
        <button *ngIf="!isWaiting" type="button" class="btn btn-outline-secondary btn-lg"
            (click)="modal.dismiss('Cross click')">Cancel</button>
        <button *ngIf="!isWaiting" [disabled]="!(isInputValid() && enteredStudentExists())" type="button"
            class="btn btn-primary btn-lg" (click)="moveStudentToNewClass()">Move</button>
        <button *ngIf="!isWaiting" [disabled]="!isInputValid() || enteredStudentExists()" type="button"
            class="btn btn-primary btn-lg" (click)="modalSubmitted()">Create</button>
        <app-loading-spinner *ngIf="isWaiting"></app-loading-spinner>
    </div>
</ng-template>

<button *ngIf="openModalButtonVisible" class="btn btn-primary" (click)="openForNew()">+ ADD STUDENT</button>